import { categories } from "@/mocks/categories";

interface Props {
  activeCat: string;
  keyword: string;
  sort: "latest" | "hot";
  onCatChange: (id: string) => void;
  onKeywordChange: (v: string) => void;
  onSortChange: (v: "latest" | "hot") => void;
  resultCount: number;
}

export default function FilterBar({
  activeCat,
  keyword,
  sort,
  onCatChange,
  onKeywordChange,
  onSortChange,
  resultCount,
}: Props) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-4">
        <div className="relative flex-1">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base" />
          <input
            type="search"
            value={keyword}
            onChange={(e) => onKeywordChange(e.target.value)}
            placeholder="搜索标题、摘要或标签关键词"
            className="w-full pl-9 pr-4 py-2.5 rounded-md border border-background-300 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
          />
        </div>

        <div className="flex items-center gap-1.5 p-1 rounded-full bg-background-100 border border-background-200 w-fit">
          {(
            [
              { key: "latest", label: "最新", icon: "ri-time-line" },
              { key: "hot", label: "最热", icon: "ri-fire-line" },
            ] as const
          ).map((s) => (
            <button
              key={s.key}
              type="button"
              onClick={() => onSortChange(s.key)}
              className={`px-3.5 py-1.5 rounded-full text-sm flex items-center gap-1.5 transition-colors cursor-pointer whitespace-nowrap ${
                sort === s.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              <i className={s.icon} />
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => onCatChange("all")}
          className={`px-3 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
            activeCat === "all"
              ? "bg-foreground-950 text-background-50"
              : "border border-background-300 text-foreground-600 hover:border-foreground-400"
          }`}
        >
          全部栏目
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            onClick={() => onCatChange(cat.id)}
            className={`px-3 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
              activeCat === cat.id
                ? "bg-foreground-950 text-background-50"
                : "border border-background-300 text-foreground-600 hover:border-foreground-400"
            }`}
          >
            {cat.name}
          </button>
        ))}
        <span className="ml-auto text-xs text-foreground-500">共 {resultCount} 条</span>
      </div>
    </div>
  );
}